module.exports = __webpack_public_path__ + "static/william-1-25ae3117e63498bbe6ac80b3d4f7f583.png";